<template>
  <b-list-group>
    <b-list-group-item v-for="message in messages" :key="message._id">
      <MessageItem :author="message.author" :body="message.body"></MessageItem>
    </b-list-group-item>
  </b-list-group>
</template>

<script>
  import MessageItem from '@/components/MessageItem'

  export default {
    name: 'MessageList',
    components: {
      MessageItem
    },
    props: {
      messages: Array
    }
  }
</script>
